import { formatMoscowDate, formatMoscowDateTime, parseUtcDateTime } from "./moscowDateTime";

export const formatUtcToMsk = (value: string): string => {
    const date = parseUtcDateTime(value)
    const hasTime = value.includes(' ') || value.includes('T')

    return hasTime
        ? formatMoscowDateTime(date)
        : formatMoscowDate(date, {})
};
